<div class="py-4 px-0">
  <div class="container">
    <h1>{{ "userDetails.title" | translate }}</h1>

    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <div class="form-group" formGroupName="notifications">
        <span class="d-inline-block mb-2">{{ "userDetails.emails.subTitle" | translate }}</span>

        <div class="form-check">
          <input type="checkbox" class="form-check-input" id="newRatings" formControlName="newRatings" />

          <label class="form-check-label" for="newRatings">{{ "userDetails.emails.newRatings" | translate }}</label>
        </div>

        <div class="form-check">
          <input type="checkbox" class="form-check-input" id="almostExpired" formControlName="almostExpired" />

          <label class="form-check-label" for="almostExpired">
            {{ "userDetails.emails.almostExpired" | translate }}
          </label>
        </div>

        <div class="form-check">
          <input type="checkbox" class="form-check-input" id="termsUpdated" formControlName="termsUpdated" />

          <label class="form-check-label" for="termsUpdated">
            {{ "userDetails.emails.termsUpdated" | translate }}
          </label>
        </div>
      </div>

      <div class="form-group">
        <label for="email">{{ "userDetails.email.label" | translate }}</label>

        <input
          type="email"
          class="form-control"
          id="email"
          formControlName="email"
          [ngClass]="{ 'is-valid': authService.getUserData()?.email === emailCtrl.value && authService.hasVerifiedEmail() }" />
      </div>

      <p>{{ "userDetails.allowTransfer.helpText" | translate }}</p>

      <div class="form-group">
        <div class="form-check">
          <input type="checkbox" class="form-check-input" id="allowTransfer" formControlName="allowTransfer" />

          <label class="form-check-label" for="allowTransfer">
            {{ "userDetails.allowTransfer.label" | translate }}
          </label>
        </div>
      </div>

      <button
        type="submit"
        class="btn btn-blue"
        [ngClass]="{ 'mb-4': authService.hasEmail() && !authService.hasVerifiedEmail() }"
        [disabled]="form.invalid || form.pristine">
        {{ "forms.common.save" | translate }}
      </button>
    </form>

    @if (authService.hasEmail() && !authService.hasVerifiedEmail()) {
      <alert type="confirm">
        {{ "userDetails.email.confirm" | translate }}
      </alert>
    }
  </div>
</div>
